module.exports = require('./prefixer')()


//////////////////
// WEBPACK FOOTER
// ./~/to-style/src/cssPrefix.js
// module id = 2588
// module chunks = 0